<aw-dialog
  (onClose)="dialogRef.close($event)"
  [content]="content"
  [width]="width"
  [data]="data"
  [title]="data.headline"
  [subtitle]="data.selectedTicket.name"
  [footer]="footer">
  <ng-template #content>
    <div class="w-full" [formGroup]="form">
      <aw-simple-table
        id="layout-assignment-table"
        [data]="rows"
        [isLoading]="layoutsStore.isLoading()"
        density="compact"
        [header]="tableHeader"
        [columns]="tableColumns"
        [showLastRowBorder]="true">
        <ng-template #tableHeader>
          <div>Fahrschein</div>
          <div>Ticket-Layout</div>
        </ng-template>

        <ng-template #tableColumns let-row="data" let-index="index">
          <div class="min-w-0">
            <span class="truncate" [title]="row.sortId">
              {{ row.sortId }}
            </span>
          </div>
          <div>
            <aw-drop-down
              class="w-full"
              [id]="'layout-assignment-' + index"
              appearance="compact"
              [options]="layoutOptions()"
              name="layoutName"
              valueAttribute="id"
              [formControl]="row.layoutIdControl" />
          </div>
        </ng-template>
      </aw-simple-table>
    </div>
  </ng-template>

  <ng-template #footer>
    <div class="flex w-full justify-end gap-2">
      <aw-button
        id="cancel-layout-assignment"
        type="button"
        [style]="'primary-alt'"
        [text]="cmsTextProvider.shared.cancel"
        (click)="dialogRef.close()" />
      <aw-button
        id="confirm-layout-assignment"
        type="button"
        [style]="'primary'"
        [text]="cmsTextProvider.shared.confirm"
        (click)="confirm()" />
    </div>
  </ng-template>
</aw-dialog>
